import React, { useState } from "react";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export default function MyErrorModal() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="danger" onClick={handleShow}>
        My Error Modal
      </Button>

      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        contentClassName="bg-purple-gradient-darker-reverse"
        style={{ minHeight: 300 }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="px-4">Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="px-4">
            <div className="bg-red-error text-white p-3 rounded-3 mb-5">
              ERROR MESSAGE EXAMPLE
            </div>
            <div className="d-flex justify-content-between my-3 gap-3">
              <Form.Control
                placeholder="Title:"
                name="title"
                as="textarea"
                className="rounded-3 fw-bold"
              />
              <Form.Control
                placeholder="Name:"
                name="name"
                as="textarea"
                className="rounded-3 fw-bold"
              />
            </div>
            <div className="d-flex justify-content-end gap-2 mt-5">
              <Button
                className="btn btn-sm btn-dark text-white rounded-pill  px-5"
                onClick={handleClose}
              >
                CANCEL
              </Button>
              <Button
                className="btn btn-sm btn-colored-reverse rounded-pill px-5"
                onClick={handleClose}
              >
                SAVE
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
